exports.node = function(value) {
  return value !== void 0 && value instanceof HTMLElement && value.nodeType === 1;
};
exports.nodeList = function(value) {
  var type = Object.prototype.toString.call(value);
  return value !== void 0 && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
};
exports.string = function(value) {
  return typeof value === "string" || value instanceof String;
};
exports.fn = function(value) {
  var type = Object.prototype.toString.call(value);
  return type === "[object Function]";
};
